import React from 'react';
import { Checkbox,TextField, Grid, Typography } from "@mui/material";
import InputAdornment from "@material-ui/core/InputAdornment";
import "./styles.css";

const Labour = () => {
    return (
        <Grid className="labour" display="flex" flexDirection='column'>
            <Typography style ={{fontWeight:'600'}}>Labour cost Details</Typography>
            <Grid display='flex' style ={{marginTop:'20px', justifyContent:'space-around'}}>
            <Grid display="flex" flexDirection='column' >
              <Typography className="quoteLabelCls">Labour cost</Typography>
              <TextField
                textFieldStyle={{ width: "100%" }}
                value={'38.00'}
                InputLabelProps={{ style: { fontSize: 40, paddingTop: 0 } }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" size="small">
                      <span
                        style={{
                          borderLeft: "1.5px solid #3C8C9E",
                          paddingLeft: "10px",
                          fontWeight:'600'
                        }}
                      >R
                      </span>
                    </InputAdornment>
                  ),
                  readOnly:true,
                  style: { fontSize: 16 },
                }}
              />
             </Grid>
             <Grid display="flex" flexDirection='column'>
              <Typography className="quoteLabelCls">Call out fee</Typography>
              <TextField
                textFieldStyle={{ width: "100%" }}
                value={'8.00'}
                InputLabelProps={{ style: { fontSize: 40, paddingTop: 0 } }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" size="small">
                       <span
                        style={{
                          borderLeft: "1.5px solid #3C8C9E",
                          paddingLeft: "10px",
                          fontWeight:'600'
                        }}
                      >R
                      </span>
                    </InputAdornment>
                  ),
                  readOnly:true,
                  style: { fontSize: 16 },
                }}
              />
             </Grid>
             <Grid display="flex" flexDirection='column'>
              <Typography className="quoteLabelCls">Total time needed</Typography>
              <TextField
                value={'2.5 hrs'}
                textFieldStyle={{ width: "100%" }}
                InputLabelProps={{ style: { fontSize: 40, paddingTop: 0 } }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end" size="small">
                    </InputAdornment>
                  ),
                  readOnly:true,
                  style: { fontSize: 16 },
                }}
              />
             </Grid> 
             </Grid>
              <Grid item sm={6} p={2} className="grid">
                <div className="checkboxDs">
                  <Checkbox
                    style={{ paddingLeft: "0px" }}
                    checked={true}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  <span style={{fontSize:'16px'}}>Added call out fee to labour cost</span>
                </div>
              </Grid>
              
            </Grid>
    );
};

export default Labour;